var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWithoutPallets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5627 19.7441H37.616C37.424 18.2531 36.6954 16.8832 35.5666 15.8904C34.4377 14.8977 32.9859 14.3501 31.4827 14.3501C29.9794 14.3501 28.5276 14.8977 27.3988 15.8904C26.2699 16.8832 25.5414 18.2531 25.3493 19.7441H21.4027C20.5825 19.7448 19.7961 20.071 19.2161 20.6509C18.6362 21.2309 18.31 22.0173 18.3093 22.8374V41.9308C18.31 42.751 18.6362 43.5373 19.2161 44.1173C19.7961 44.6973 20.5825 45.0234 21.4027 45.0241H41.5894C42.4095 45.0234 43.1959 44.6973 43.7759 44.1173C44.3558 43.5373 44.6819 42.751 44.6827 41.9308V22.8374C44.6819 22.0173 44.3558 21.2309 43.7759 20.6509C43.1959 20.071 42.4095 19.7448 41.5894 19.7441H41.5627ZM26.4427 19.7441C26.6187 18.5402 27.2222 17.4398 28.1427 16.6442C29.0632 15.8485 30.2393 15.4106 31.456 15.4106C32.6727 15.4106 33.8488 15.8485 34.7693 16.6442C35.6898 17.4398 36.2933 18.5402 36.4694 19.7441H26.416H26.4427ZM24.736 42.8374L21.616 39.2108H23.6694V35.5841H25.8293V39.2108H27.8827L24.7627 42.8374H24.736ZM37.8827 42.8374L34.7627 39.2108H36.816V35.5841H38.976V39.2108H41.0293L37.9093 42.8374H37.8827Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 4.0013C16.5348 4.0013 3.99988 16.538 3.99988 32.0002C3.99988 47.4623 16.5348 59.999 32 59.999C47.4652 59.999 60.0001 47.4623 60.0001 32.0002C60.0001 16.538 47.4652 4.0013 32 4.0013ZM0.00012207 32.0002C0.00012207 14.3252 14.3281 -0.000976562 32 -0.000976562C49.6719 -0.000976562 63.9999 14.3252 63.9999 32.0002C63.9999 49.6751 49.6719 64.0013 32 64.0013C14.3281 64.0013 0.00012207 49.6751 0.00012207 32.0002Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1153 55.638L8.03794 11.286L10.8741 8.46387L54.9514 52.8159L52.1153 55.638Z",
    fill: "#FF0033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithoutPallets);
export default __webpack_public_path__ + "static/media/icon-without-pallets.c8b4df2bfaa4a134a2679bb6c1471e4f.svg";
export { ForwardRef as ReactComponent };